import { Features } from '@src/core/features';
import { getNavBarMenuRolesByAction } from '@src/roles';
import { FC, PropsWithChildren } from 'react';
import NotFoundPage from '../../not-found.page';
import { useSessionContext } from '../authentication';
import { useProjectContext } from '../switch-project';

/**
 * O menu escondia o item e a rota ficava aberta: quem digitasse /statistics
 * entrava do mesmo jeito. A lista de papeis ja existia em roles.ts, sem nenhum
 * consumidor, entao o gate e a mesma regra que o menu agora aplica.
 *
 * Quem nao tem acesso ve a mesma pagina de qualquer endereco inexistente, em vez
 * de ser levado para outra rota: nao adianta esconder a tela e entregar, no
 * redirecionamento, a informacao de que ela existe.
 */
const StatisticsGuard: FC<PropsWithChildren> = ({ children }) => {
  const { allowAccess } = useSessionContext();
  const { allowedFeature } = useProjectContext();

  if (!allowAccess(getNavBarMenuRolesByAction(Features.STATISTICS)) || !allowedFeature(Features.STATISTICS)) {
    return <NotFoundPage />;
  }

  return <>{children}</>;
};

export { StatisticsGuard };
